import React, { useState } from 'react';

const PolicyModal = ({ isOpen: controlledOpen, onClose: controlledClose } = {}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  // Controlled mode (parent passes isOpen/onClose) vs uncontrolled (renders its
  // own trigger button — the Footer use case). Both kept so existing call-sites
  // that drop <PolicyModal /> in keep working unchanged.
  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? controlledOpen : internalOpen;
  const close = isControlled
    ? () => controlledClose && controlledClose()
    : () => setInternalOpen(false);

  return (
    <>
      {!isControlled && (
        <button
          className="text-lg font-semibold mb-4 text-indigo-700 hover:text-indigo-900 transition"
          onClick={() => setInternalOpen(true)}
        >
          Politica de cookie
        </button>
      )}

      {isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/60 z-[9999] backdrop-blur-sm animate-fadeIn"
          onClick={close}
        >
          <div
            className="relative bg-gradient-to-br from-white via-indigo-50 to-blue-50 p-8 rounded-2xl shadow-2xl w-11/12 max-w-lg mx-auto overflow-y-auto max-h-[80vh] border border-indigo-100 animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              className="absolute top-3 right-3 text-red-500 bg-white rounded-full shadow-lg p-2 hover:bg-red-50 hover:scale-110 transition z-10"
              onClick={close}
              aria-label="Închide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Modal content */}
            <h2 className="text-2xl font-extrabold mb-6 text-indigo-800 text-center drop-shadow-sm">
              Politica de Cookie
            </h2>
            <div className="space-y-5 text-base">
              <p className="text-gray-700">
                Această politică de cookie explică ce sunt cookie-urile și cum
                le utilizăm pe platforma{' '}
                <span className="font-semibold text-indigo-700">
                  {import.meta.env.VITE_NAME}
                </span>
                . Te rugăm să citești cu atenție această politică pentru a
                înțelege ce tipuri de cookie-uri utilizăm, informațiile
                colectate și modul în care acestea sunt folosite.
              </p>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  Ce sunt cookie-urile?
                </p>
                <p className="text-gray-700">
                  Cookie-urile sunt fișiere mici de text stocate pe dispozitivul
                  tău atunci când vizitezi un site web. Acestea permit site-ului
                  să rețină informații despre vizita ta, cum ar fi preferințele
                  sau activitatea anterioară.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  Tipuri de cookie-uri pe care le folosim:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                  <li>
                    <span className="font-semibold text-indigo-700">
                      Cookie-uri esențiale:
                    </span>{' '}
                    Necesare pentru funcționarea corectă a platformei.
                  </li>
                  <li>
                    <span className="font-semibold text-indigo-700">
                      Cookie-uri de performanță:
                    </span>{' '}
                    Ajută la analizarea utilizării site-ului pentru a îmbunătăți
                    experiența utilizatorilor.
                  </li>
                  <li>
                    <span className="font-semibold text-indigo-700">
                      Cookie-uri de funcționalitate:
                    </span>{' '}
                    Rețin preferințele tale pentru a oferi o experiență
                    personalizată.
                  </li>
                  <li>
                    <span className="font-semibold text-indigo-700">
                      Cookie-uri de marketing:
                    </span>{' '}
                    Utilizate pentru a afișa anunțuri relevante în funcție de
                    interesele tale.
                  </li>
                </ul>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  Gestionarea cookie-urilor
                </p>
                <p className="text-gray-700">
                  Poți controla cookie-urile din setările browserului tău.
                  Totuși, dezactivarea anumitor cookie-uri poate afecta
                  funcționalitatea platformei.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">Contact</p>
                <p className="text-gray-700">
                  Pentru orice întrebări suplimentare despre utilizarea
                  cookie-urilor, te rugăm să ne contactezi la adresa{' '}
                  <a
                    href="mailto:office@licitatii-constructii.ro"
                    className="font-mono text-indigo-700 underline hover:text-indigo-900"
                  >
                    office@licitatii-constructii.ro
                  </a>
                  .
                </p>
              </div>
            </div>
            {/* Close button inside modal */}
            <button
              className="bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold py-2 px-4 rounded-xl hover:from-indigo-700 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 mt-8 w-full shadow-lg transition"
              onClick={close}
            >
              Închide
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PolicyModal;
